import { AnniversaryPage } from "../components/BirthdayCard";

export default AnniversaryPage;
